$(function() {
    const TOTAL_DURATION = 2000;
    const HOLD_DELAY = 250;

    function setLog(msg, type) {
        const dotColors = {
        cancel: '#E24B4A',
        success: '#1D9E75',
        idle: 'var(--color-border-secondary)',
        hold: '#534AB7'
        };
        $('#log-dot').css('background', dotColors[type] || dotColors.idle);
        $('#log-msg').text(msg);
    }

    function onUserCancelledHold(productId) {
        getClassicProductExtraModal(productId)
    }

    function onHoldComplete(productId) {
                
        $.ajax({
          type: "POST",
          url: "/api/v1/private/products/get-product-details",
          data: { product_id: productId },
          timeout: 10000,
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#content").append(data.html);
              $("#product-details-modal").modal("show");
            }
          })
          .fail(function (xhr) {
            console.error("Failed to load product details:", xhr);
            if (xhr.responseJSON?.redirect_url) {
              window.location.href = xhr.responseJSON.redirect_url;
            }
          });
    }
    
    $(".shop-product-container").each(function() {
        const $wrap = $(this);
        const $card = $wrap.find('.shop-product');
        const $svg  = $wrap.find('.ring-svg');
        const $productId = $wrap.data('product-id');
        const forcedProductExtraPopup = $wrap.attr('data-force-product-extra-popup') === 1;
        const hasProductExtra = $wrap.attr('data-has-product-extra') === 1;

        // Dynamically calculate ring color based on card's background color
        let ringColor = '#ffffff';
        let shadowColor = 'rgba(0,0,0,0.35)';
        const bgColor = $card.css('background');

        if (bgColor) {
            const rgbMatch = bgColor.match(/\d+/g);
            if (rgbMatch && rgbMatch.length >= 3) {
                const r = parseInt(rgbMatch[0], 10);
                const g = parseInt(rgbMatch[1], 10);
                const b = parseInt(rgbMatch[2], 10);
                
                // YIQ brightness
                const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                
                if (yiq >= 128) {
                    ringColor = '#111111';
                    shadowColor = 'rgba(255, 255, 255, 0.6)';
                } else {
                    ringColor = '#ffffff';
                    shadowColor = 'rgba(0, 0, 0, 0.35)';
                }
            }
        }

        let anim = null;
        let going = false;
        let currentPerim = 0;
        let resetTimeout = null;
        let intentTimeout = null;

        function createRing() {
        // getBoundingClientRect ensures exact floating-point sizes, regardless of grid stretch
        const rect = $card[0].getBoundingClientRect();
        const padding = 2;
        const w = rect.width + padding;
        const h = rect.height + padding;

        $svg.attr({ width: w + 2, height: h + 2 });

        const x = 4;
        const y = 4;
        const width = w - 2;
        const height = h - 2;
        const r = 8;

        // Exact perimeter of a rectangle with rounded corners
        currentPerim = 2 * (width - 2 * r) + 2 * (height - 2 * r) + 2 * Math.PI * r;

        const topHalf = (width - 2 * r) / 2;
        const startOffset = -topHalf;   

        // Base Opacity is 0
        $svg.html(`
            <rect class="r-track" 
                x="${x}" y="${y}" 
                width="${width}" height="${height}" 
                rx="${r}" 
                fill="none" 
                stroke="${ringColor}" 
                stroke-width="3" 
                style="opacity: 0;"/>

            <rect class="r-shadow" 
                x="${x}" y="${y}" 
                width="${width}" height="${height}" 
                rx="${r}" 
                fill="none" 
                stroke="${shadowColor}" 
                stroke-width="5.5"
                stroke-linecap="round"
                stroke-dasharray="0 ${currentPerim}" 
                stroke-dashoffset="${startOffset}"
                style="opacity: 0;"/>

            <rect class="r-prog" 
                x="${x}" y="${y}" 
                width="${width}" height="${height}" 
                rx="${r}" 
                fill="none" 
                stroke="${ringColor}" 
                stroke-width="3" 
                stroke-linecap="round"
                stroke-dasharray="0 ${currentPerim}" 
                stroke-dashoffset="${startOffset}"
                style="opacity: 0;"/>
        `);

        return startOffset;
        }

        let initialOffset = createRing();

        // ResizeObserver watches the card dynamically. 
        // Any time the CSS grid changes the card size, the SVG redraws perfectly around it.
        const resizeObserver = new ResizeObserver(() => {
        if (!going) initialOffset = createRing();
        });
        resizeObserver.observe($card[0]);

        function reset() {
        $svg.find('.r-track').css('opacity', 0);
        $svg.find('.r-prog, .r-shadow')
            .attr('stroke-dasharray', `0 ${currentPerim}`)
            .attr('stroke-dashoffset', initialOffset)
            .css('opacity', 0);
        }

        function start() {
        if (going) return;
        going = true;
        
        if (resetTimeout) {
            clearTimeout(resetTimeout);
            resetTimeout = null;
        }

        intentTimeout = setTimeout(() => {
            // One last calculation just in case layout shifted right before click
            initialOffset = createRing(); 

            const $track = $svg.find('.r-track');
            const $prog  = $svg.find('.r-prog');
            const $shad  = $svg.find('.r-shadow');
            
            $track.css('opacity', 0.13);
            $prog.css('opacity', 1);
            $shad.css('opacity', 1);

            anim = { v: 0 };
            $(anim).animate({ v: currentPerim }, {
            duration: TOTAL_DURATION - HOLD_DELAY, 
            easing: 'linear',
            step: function(val) {
                val = Math.max(0, Math.min(val, currentPerim));
                const remain = currentPerim - val;
                
                $prog.attr('stroke-dasharray', `${val} ${remain}`);
                $shad.attr('stroke-dasharray', `${val} ${remain}`);

                if (hasProductExtra && !forcedProductExtraPopup) {
                    onUserCancelledHold($productId);
                }
            },
            complete: function() {
                going = false;
                anim = null;
                resetTimeout = setTimeout(reset, 700);

                onHoldComplete($productId);
            }
            });
        }, HOLD_DELAY);
        }

        function cancel() {
            if (!going) return;
            going = false;
            
            if (intentTimeout) {
                clearTimeout(intentTimeout);
                intentTimeout = null;
            }
            
            if (anim) {
                $(anim).stop(true);
                anim = null;
            }
            
            reset();
        }

        $card
        .on('mousedown touchstart', function(e) {
            e.preventDefault();
            start();
        })
        .on('mouseup mouseleave touchend touchcancel', function() {
            if (going) cancel();
        });
    });
})